(()=>{
    new Swiper('#header-trusted-us-slider', {
        slidesPerView: 2,
        speed: 800,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        spaceBetween: 40,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 3
            },
            1280: {
                slidesPerView: 4
            }
        }
    });
})();
(()=>{
    const productsFilterBtns = document.querySelectorAll('[data-filter-category]');
    const filterableProducts = document.querySelectorAll('[data-category]');
    console.log(productsFilterBtns);
    let selectedFilter = false;
    function filterProducts(filterName) {
        console.log(filterName);
        filterableProducts.forEach((product)=>{
            if (product.dataset.category != filterName) {
                product.classList.add('hidden');
                console.log(product);
            } else product.classList.remove('hidden');
        });
    }
    function initialAction() {
        const firstCategory = productsFilterBtns[0].dataset.filterCategory;
        selectedFilter = firstCategory;
        filterProducts(selectedFilter);
    }
    window.addEventListener('load', initialAction);
    productsFilterBtns.forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
            e.preventDefault();
            filterProducts(btn.dataset.filterCategory);
        });
    });
})();
(()=>{
    new Swiper('#pros-slider', {
        slidesPerView: 1,
        spaceBetween: 64,
        speed: 1200,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        loop: true,
        navigation: {
            prevEl: '#slider-pros-prev',
            nextEl: '#slider-pros-next'
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            },
            1280: {
                slidesPerView: 4
            }
        }
    });
})();
// (() => {
//     document.addEventListener('DOMContentLoaded', function () {
//         const form = document.getElementById('offerForm');
//         // Obsługa zdarzenia `submit`
//         form.addEventListener('submit', function (e) {
//           // Zatrzymaj domyślne wysłanie formularza
//           e.preventDefault();
//           // Pobieramy elementy formularza
//           const fullName = document.getElementById('form_full_name');
//           const email = document.getElementById('form_email');
//           const phone = document.getElementById('form_phone');
//           const companyName = document.getElementById('form_company_name');
//           const vatNumber = document.getElementById('form_vat_number');
//           const acceptance = document.getElementById('form_acceptance');
//           // Jeśli walidacja OK, zbieramy dane w obiekt (przykład: JSON)
//           const payload = {
//             form_full_name: fullName.value.trim(),
//             form_email: email.value.trim(),
//             form_phone: phone.value.trim(),
//             form_company_name: companyName.value.trim(),
//             form_vat_number: vatNumber.value.trim(),
//             form_acceptance: acceptance.checked
//           };
//           // Wysyłamy zapytanie POST do webhooka w Make.com
//           fetch('https://hook.eu2.make.com/jtx39qvbstbjsn7iy88x0ay6okyib5s2', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(payload)
//           })
//           .then(response => {
//             // Obsługa odpowiedzi z serwera (Make)
//             if (response.ok) {
//               alert('Dane zostały wysłane poprawnie!');
//               form.reset(); // Czyścimy formularz
//             } else {
//               alert('Wystąpił błąd podczas wysyłania danych. Spróbuj ponownie.');
//             }
//           })
//           .catch((error) => {
//             // Obsługa błędu sieci
//             alert('Błąd sieci. Spróbuj ponownie później.');
//             console.error(error);
//           });
//         });
//     });
// })();
(()=>{
    const form = document.getElementById('offerForm');
    const headerEmailForm = document.getElementById('header_email');
    const contactFromSection = document.getElementById('contact-form');
    headerEmailForm.addEventListener('submit', (e)=>{
        e.preventDefault();
        const headerFormData = new FormData(headerEmailForm);
        const email = headerFormData.get('header_email');
        window.scrollTo({
            left: 0,
            top: contactFromSection.offsetTop - 150,
            behavior: 'smooth'
        });
        form.elements.form_email.value = email;
    });
})();

//# sourceMappingURL=index.73fa661b.js.map
